import { createSlice } from "@reduxjs/toolkit";
import { ApplicationRootState } from "types";
import { MemberStateType } from "types/member";

import { extraReducers } from "./member.extraReducers";

export const initialState: MemberStateType = {
  isLoading: false,
  dataMessageMember: {
    data: [],
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    totalPages: 0,
  },
  dataPromotionMember: {
    data: [],
    totalCount: 0,
    currentPage: 1,
    pageSize: 100,
    totalPages: 0,
  },
  dataVipMember: {
    data: {
      total_level: 0,
      current_level: 0,
      next_level: {
        level: 0,
        turnover: "",
        current_turnover: "",
        turnover_percentage: "",
      },
      benefit: {
        birthday_bonus: "",
        upgrade_reward: "",
      },
      rebate: {
        LC: "",
        SL: "",
        SB: "",
        FH: "",
        ES: "",
        BG: "",
        LT: "",
        KN: "",
        CF: "",
        OT: "",
      },
    },
  },
};

const memberSlice = createSlice({
  name: "member",
  initialState,
  reducers: {
    //
  },
  extraReducers,
});

export const selectDataMessageMember = (state: ApplicationRootState) =>
  state.member.dataMessageMember;

export const selectDataVipMember = (state: ApplicationRootState) =>
  state.member.dataVipMember.data;

export const selectDataPromotionMember = (state: ApplicationRootState) =>
  state.member.dataPromotionMember;

export const selectIsLoadingMessageMember = (state: ApplicationRootState) =>
  state.member.isLoading;

export default memberSlice.reducer;
